import axios from 'axios'
import constants from '../constants'
import HttpService from './http.service'

const handleResponse = response => {
  return response.data.result;
}

class RegistrationService extends HttpService {
  fetchRegistrationStatus(eventId) {
    return axios
      .get(
        `${constants.API.URL}/events/${eventId}/registration`,
        this.getOptions()
      )
      .then(handleResponse)
      .catch(this.onError)
  }

  fetchRegistrationForm(eventId) {
    return axios
      .get(
        `${constants.API.URL}/events/${eventId}/registration_form`,
        this.getOptions()
      )
      .then(handleResponse)
      .then(result => (result && result.fields) || [])
      .catch(this.onError)
  }
}

export default new RegistrationService()
